import { useCallback } from "react";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import MobileCTABar from "@/components/MobileCTABar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ServiceMarquee from "@/components/sections/ServiceMarquee";
import Problem from "@/components/sections/Problem";
import Services from "@/components/sections/Services";
import CompleteCare from "@/components/sections/CompleteCare";
import WhyChoose from "@/components/sections/WhyChoose";
import Process from "@/components/sections/Process";
import ServiceArea from "@/components/sections/ServiceArea";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import EnquiryForm from "@/components/sections/EnquiryForm";

export default function Landing() {
  const scrollToQuote = useCallback(() => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <SmoothScroll>
      <div className="min-h-screen bg-white overflow-x-hidden">
        <Header onQuote={scrollToQuote} />
        <main>
          <Hero onQuote={scrollToQuote} />
          <ServiceMarquee />
          <Problem onQuote={scrollToQuote} />
          <Services onQuote={scrollToQuote} />
          <CompleteCare />
          <WhyChoose />
          <Process onQuote={scrollToQuote} />
          <ServiceArea />
          <Testimonials />
          <FAQ />
          <FinalCTA onQuote={scrollToQuote} />
          <EnquiryForm />
        </main>
        <Footer />
        <MobileCTABar onQuote={scrollToQuote} />
      </div>
    </SmoothScroll>
  );
}
